import { useEffect, useState } from "react";

import GenericCard from "widgets/cards/generic";
import WaterRateForm from "widgets/forms/sites/rates/water";
import SewerageRateForm from "widgets/forms/sites/rates/sewerage";
import ElectricityRateForm from "widgets/forms/sites/rates/electricity";
import { Site } from "api/types/site";
import { ratesRateGetActive } from "api/rates";
import { RateResponse } from "api/types/rates";
import OtherRateForm from "widgets/forms/sites/rates/other";
import NoRatesSvg from "../../../../../assets/svg/no-rates.svg";
import GasRateForm from "widgets/forms/sites/rates/gas";
import { useTranslation } from "react-i18next";

interface GeneralProps {
  site?: Site;
  onUpdate?: () => void;
}

const Rates: React.FC<GeneralProps> = ({ site, onUpdate }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const [rates, setRates] = useState<RateResponse>(null);

  const fetchData = async () => {
    setRates(null);
    setLoading(true);
    const { data, status, isLoading } = await ratesRateGetActive(site?.id);
    setLoading(isLoading);
    if (status && status === 200) {
      setRates(data.rates);
    }
  };

  useEffect(() => {
    if (site && site.id) {
      fetchData();
    }
  }, [site]);

  return (
    <div className="w-full overflow-x-auto">
      <div className="flex h-full gap-4">
        <GenericCard
          title={t("site.rates.water")}
          description={t("site.rates.display")}
          extraDescription="text-secondary text-txt-sm"
          extra="h-full min-w-[300px] max-w-[320px] flex-shrink-0"
        >
          <div className="mt-4 flex h-full w-full flex-col gap-6 overflow-y-auto">
            {!loading && rates?.water ? (
              <>
                <WaterRateForm
                  defaultValues={rates?.water}
                  submit={() => {}}
                  onClose={() => {}}
                  disabled
                />
              </>
            ) : (
              <div className="mt-10 flex justify-center">
                <img
                  src={NoRatesSvg}
                  alt="Modal content"
                  style={{ width: "30%" }}
                />
              </div>
            )}
          </div>
        </GenericCard>
        <GenericCard
          title={t("site.rates.sewerage")}
          description={t("site.rates.display")}
          extraDescription="text-secondary text-txt-sm"
          extra="h-full min-w-[300px] max-w-[320px] flex-shrink-0"
        >
          <div className="mt-4 flex h-full w-full flex-col gap-6 overflow-y-auto">
            {!loading && rates?.sewerage ? (
              <>
                <SewerageRateForm
                  defaultValues={rates?.sewerage}
                  submit={() => {}}
                  onClose={() => {}}
                  disabled
                />
              </>
            ) : (
              <div className="mt-10 flex justify-center">
                <img
                  src={NoRatesSvg}
                  alt="Modal content"
                  style={{ width: "30%" }}
                />
              </div>
            )}
          </div>
        </GenericCard>
        <GenericCard
          title={t("site.rates.electricity")}
          description={t("site.rates.display")}
          extraDescription="text-secondary text-txt-sm"
          extra="h-full min-w-[300px] max-w-[320px] flex-shrink-0"
        >
          <div className="mt-4 flex h-full w-full flex-col gap-6 overflow-y-auto">
            {!loading && rates?.electricity ? (
              <>
                <ElectricityRateForm
                  defaultValues={rates?.electricity}
                  submit={() => {}}
                  onClose={() => {}}
                  disabled
                />
              </>
            ) : (
              <div className="mt-10 flex justify-center">
                <img
                  src={NoRatesSvg}
                  alt="Modal content"
                  style={{ width: "30%" }}
                />
              </div>
            )}
          </div>
        </GenericCard>
        <GenericCard
          title={t("site.rates.gas")}
          description={t("site.rates.display")}
          extraDescription="text-secondary text-txt-sm"
          extra="h-full min-w-[300px] max-w-[320px] flex-shrink-0"
        >
          <div className="mt-4 flex h-full w-full flex-col gap-6 overflow-y-auto">
            {!loading && rates?.gas ? (
              <>
                <GasRateForm
                  defaultValues={rates?.gas}
                  submit={() => {}}
                  onClose={() => {}}
                  disabled
                />
              </>
            ) : (
              <div className="mt-10 flex justify-center">
                <img
                  src={NoRatesSvg}
                  alt="Modal content"
                  style={{ width: "30%" }}
                />
              </div>
            )}
          </div>
        </GenericCard>
        <GenericCard
          title={t("site.rates.other")}
          description={t("site.rates.display")}
          extraDescription="text-secondary text-txt-sm"
          extra="h-full min-w-[300px] max-w-[320px] flex-shrink-0"
        >
          <div className="mt-4 flex h-full w-full flex-col gap-6 overflow-y-auto">
            {!loading && rates?.other ? (
              <>
                <OtherRateForm
                  submit={() => {}}
                  onClose={() => {}}
                  disabled
                  defaultValues={{ other: rates?.other }}
                />
              </>
            ) : (
              <div className="mt-10 flex justify-center">
                <img
                  src={NoRatesSvg}
                  alt="Modal content"
                  style={{ width: "30%" }}
                />
              </div>
            )}
          </div>
        </GenericCard>
      </div>
    </div>
  );
};

export default Rates;
